import styled, { css } from 'styled-components';

const TableStyled = styled.table.attrs({
  className: 'table',
})`
  ${props => {
    const { theme = {}, darkMode = false, activeBgColor = undefined } = props;
    const { colors = {}, fonts = {}, media = {} } = theme;
    return css`
      overflow-x: scroll;
      display: block;
      border-collapse: collapse;

      th,
      td {
        padding: 4px;
        border: 1px solid #ccc;
      }
    `;
  }}
`;

export default TableStyled;
